// Port of DeactivatedScreen() in android/.../ui/MainActivity.kt.
// State: screen exists + is paired, but an admin toggled is_active off.
// The 30s deactivated-poll in usePlayerState resumes content automatically
// when is_active flips back, so this screen is purely a "we know we're off" hint.

// Deliberately carries NO diagnostic disconnect code. The other disconnect
// screens show one because something went wrong and an Account Manager has to
// diagnose it; deactivation is a deliberate switch someone flipped in the
// dashboard, with a known cause and a known cure. Labelling it "Error code
// 310" told the venue their screen was broken and sent them to support for a
// setting their own admin had just changed.
export default function DeactivatedScreen() {
  return (
    <div className="flex flex-col items-center gap-3 px-10 text-center max-w-md">
      <h2 className="text-white text-2xl font-semibold">Screen deactivated</h2>
      <p className="text-muted text-sm leading-relaxed">
        This screen has been deactivated from the WeTook dashboard.
        <br />It will resume automatically when reactivated.
      </p>
    </div>
  )
}
